import { NewsForm } from '../../components/forms';

export const News = () => {
  return <NewsForm />;
};
